import Link from 'next/link'

export default class extends React.Component {
  componentDidMount() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', this.scroll)
    })
  }

  componentWillUnmount() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.removeEventListener('click', this.scroll)
    });
  }

  scroll = (e) => {
    e.preventDefault()
    document.querySelector(e.srcElement.hash).scrollIntoView({
      behavior: 'smooth'
    });
  }

  render() {
    const { type } = this.props
    return (
      <nav className="container-fluid nav" id="top">
        <div className="brand">
          {
            type === 'kid' &&
            <a href="http://www.etalking.com.tw" target="_blank">
              <img src={require('../static/kid/logo.png')} alt="etalking kids logo" style={{ height: '2.6em' }}/>
            </a>
          }
          {
            type === 'kidsnew' &&
            <a href="http://www.etalking.com.tw" target="_blank">
                <img src={require('../static/kid/logo.png')} alt="etalking kids logo" style={{ height: '2.6em' }}/>
            </a>
          }
          {
            type !== 'kid' && type !== 'kidsnew' &&
            <a href="https://www.etalkingonline.com" target="_blank">
              <img src={require('../static/adult/logo.png')} alt="etalking logo" />
            </a>
          }
        </div>
        <i className="fa fa-bars nav-toggle"></i>
        <ul>
          { this.props.nav.map((item) =>
            (
              <li key={item.id}>
                { item.type &&
                  <Link href='/login'>
                    <a>{item.title}</a>
                  </Link>
                }
                { !item.type && <a href={item.href}>{item.title}</a> }
              </li>
            ))
          }
        </ul>
        <style jsx global>{`
          .container-fluid {
            position: fixed;
            top: 0;
            right: 0;
            left: 0;
            padding: 0 2em;
            display: flex;
            flex-wrap: nowrap;
            justify-content: space-between;
            background: #53cde2;
            z-index: 1000;
            opacity: 0.8;
            box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
          }

          nav a, nav a:hover, nav a:focus,  nav a:active, nav a:visited {
            text-decoration: none;
          }

          nav .brand a > img {
            height: 1.6em;
            margin: 1em 0;
          }

          nav .nav-toggle {
            color: #444;
            cursor: pointer;
            display: inline-block;
            float: right;
            font-size: 1.25em;
            padding: 1em 0;
            z-index: 1000
          }

          nav ul {
            display: flex;
            flex-direction: row;
            align-items: center;
          }

          nav ul li {
            text-align: center;
          }

          nav ul li a {
            color: #fff;
            display: block;
            padding: .75em;
          }

          nav.sticky {
            animation: show-header .5s ease;
            position: fixed;
            top: 0;
            width: 100%;
          }

          @media(max-width: 768px) {
            .container-fluid {
              //display: none;
            }
          }
        `}</style>
      </nav>
    )
  }
}
